import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { ListContent } from '@components/Feed/ListViews/components/ListContent';
import { ListMinimalUser } from '@components/Feed/ListViews/components/ListMinimalUser';
import { ToggledAvatar } from '@components/Feed/ListViews/components/ToggledAvatar';
import { Container, SubText, Wrapper } from '@components/Feed/ListViews/components/shared';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { useMediaQuery } from '@context/mediaQuery';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { MinimalUserFragmentDoc, PlaylistLikedListFragmentDoc } from '@graphql/reactQuery';
import { SPACE } from '@utils/constants';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment PlaylistLikedList on PlaylistLiked {
    id
    date
    playlist {
      id
      name
      webappUri
    }
    user {
      id
      ...MinimalUser
    }
  }
`);

export const PlaylistLikedList = ({
  activityFrag,
  playlistFeed = false,
}: {
  activityFrag: FragmentType<PlaylistLikedListFragmentDoc>;
  playlistFeed?: boolean;
}) => {
  const {
    playlist,
    user: userFrag,
    date,
  } = getFragment(PlaylistLikedListFragmentDoc, activityFrag);
  const { tablet } = useMediaQuery();

  const { avatar, username, publicAddress, webappUri } = getFragment(
    MinimalUserFragmentDoc,
    userFrag,
  );

  const user = (
    <Wrapper margin="first" className={!!playlistFeed ? '[&_h3]:text-base-s' : undefined}>
      <ListMinimalUser userFrag={userFrag} forceMobileView={!!playlistFeed} />
    </Wrapper>
  );
  return (
    <Container>
      <ToggledAvatar
        src={avatar?.url}
        username={username}
        walletAddress={publicAddress}
        userWebappUri={webappUri}
        forceMobileView={playlistFeed && tablet}
      />
      <ListContent isoDateString={date}>
        {user}
        <SubText forceMobileView={playlistFeed}>
          {playlistFeed ? 'liked this Playlist' : `liked${SPACE}`}
        </SubText>
        {!!playlist && !playlistFeed && (
          <AccessibleLink pathnameUri={webappUriPath(playlist.webappUri)}>
            <SubText black className="playlist-name" forceMobileView={playlistFeed}>
              {playlist.name}&nbsp;
            </SubText>
          </AccessibleLink>
        )}
      </ListContent>
    </Container>
  );
};
